module.exports = __webpack_public_path__ + "static/p0-7a0c8871fac3373eb00049b9f2e01e79.png";